<template>
  <div class="newPurchasingTable_box">
    <div class="table_box">
      <el-table
        :data="tableData"
        stripe
        style="
          width: 100%;
          margin: 0 auto;
          font-size: 14px;
          background: #f8f8fa;
          text-align: center;
        "
        :header-cell-style="getHeaderCellStyle"
      >
        <el-table-column v-if="showType==1" prop="isEnd" label="状态" width="110">
          <template #default="scope">
            <div
              style="
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-left: 10px;
              "
            >
              <span
                :style="!scope.row.isEnd ? 'color:#E6A340' : 'color:#009FFF'"
                >{{ scope.row.isEnd ? "进行中" : "已截止" }}</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="公告名称"
          class-name="nameFontRegular"
          width="500"
          align="center"
        >
        <template #default="row">
            <a
              href="javascript:void(0)"
              @click.prevent="handleClick(row)"
              style="color: rgb(51, 51, 51);text-decoration: none;"
              :title="row.row.name"
            >
            {{row.row.name}}
            </a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="tenderCompanyName"
          label="采购人"
          class-name="nameFontRegular"
          align="center"
        />
        <el-table-column
          v-if="showType==1"
          prop="tenderProjectClassifyCode"
          label="招采方式"
          class-name="nameFontRegular"
          width="110"
        >
        <template #default="row">
          <div style="
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-left: 10px;
                color: rgb(51, 51, 51);
              ">
            {{row.row.tenderProjectClassifyCode}}
          </div> 
        </template>
        </el-table-column>
        <el-table-column
          v-if="showType==1"
          prop="contractReckonPrice"
          label="预算金额（万元）"
          class-name="nameFontRegular"
          width="160"
        >
        <template #default="row">
          <div style="
                display: flex;
                align-items: center;
                font-size: 14px;
                margin-left: 30px;
                color: rgb(51, 51, 51);
              ">
            {{formatNumber(row.row.contractReckonPrice)}}
          </div> 
        </template>
        </el-table-column>
        <!-- <el-table-column prop="secondLevelDictName" label="类别">
          <template #default="row">
            <div style="display: flex; align-items: center; text-align: center">
              <el-tag
                style="font-size: 18px; font-weight: bold; padding: 10px"
                size="Large
"
                >{{ row.row.secondLevelDictName }}</el-tag
              >
            </div>
          </template>
        </el-table-column> -->

        <!-- <el-table-column prop="Htmlcontent" label="内容" width="180">
      <template #default="row">
        <div style="display: flex; align-items: center">
          <span
            style="color: #009fff; cursor: pointer"
            @click.prevent="handleClick(row, row.$index)"
          >
            查看详情</span
          >
        </div>
      </template>
    </el-table-column> -->

        <el-table-column
          prop="publishTime"
          label="发布时间"
          class-name="nameFontRegular"
          width="180"
        />
        <el-table-column
          v-if="showType==1"
          prop="endTime"
          label="截止时间"
          class-name="nameFontRegular"
          width="180"
        />

        <!-- <el-table-column fixed="right" label="操作" width="120">
          <template #default="row">
            <el-button
              type="primary"
              plain
              size="large"
              @click.prevent="handleClick(row)"
              style="font-weight: bold"
            >
              查看详情</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="page_box">
      <el-pagination
        style="justify-content: flex-end; margin: 20px 10px"
        v-model:currentPage="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :background="true"
        layout="total,prev, pager, next, sizes,jumper"
        :total="tableTotal"
        @size-change="ChangeSize"
        @current-change="ChangePage"
      />
      <!-- :total="tableDataLength == 0 ? 100 : tableDataLength" -->
    </div>
  </div>
</template>

<script>
import { reactive, computed, onBeforeMount, ref } from "vue";
import { mainStore, stateStore, BiddingTableStore } from "@/store";
import { storeToRefs } from "pinia";
import _ from "lodash";
import { useRouter } from "vue-router";
import { getTableList, getpriceTableList } from "@/api/index";
export default {
  props: {
    showType: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    const store = BiddingTableStore();
    onBeforeMount(async () => {
      if(props.showType==2){
        const res = await getpriceTableList({
          current: store.pricePage || 1,
          size: store.priceSize || 10,
          name: store.priceName,
          type: store.priceType || "enquiry_bulletin",
          descs: store.priceDescs || "", //倒序字段
          ascs: store.priceAscs || "", //正序字段
          tradeClassification: store.tradeClassification || "",
        });
        store.setData("priceTotal", res.data.total);
        store.setData("priceLoadData", res.data.records);
      }else{
        const res = await getTableList({
          current: store.biddingPage || 1,
          size: store.biddingSize || 10,
          name: store.biddingName,
          type: store.biddingType || "tender_bulletin",
          descs: store.biddingDescs || "", //倒序字段
          ascs: store.biddingAscs || "", //正序字段
          tradeClassification: store.tradeClassification || "",
        });
        store.setData("biddingTotal", res.data.total);
        store.setData("biddingLoadData", res.data.records);
      }
    });
    const router = useRouter();
    let tableData = computed(() => storeToRefs(store).biddingLoadData);
    let tableTotal = computed(() => storeToRefs(store).biddingTotal);
    const handleClick = (row) => {
      console.log('row',row)
      stateStore().setactiveHtml(
        row.row.content,
        row.row.name,
        row.row.publishTime,
        row.row
      );
      window.open(
        router.resolve({
          path: "/BiddingInfo",
          query: { id: row.row.id, type: (props.showType == 1?"工程招标信息详情":"竞价信息详情"), showType:props.showType, bulletinType: store.priceType, projectType: row.row.projectType},
        }).href,
        "_blank"
      );
    };
    let ChangeSize = (value) => {
      store.setData("biddingSize", value);
      store.reloadTableData(props.showType);
    };
    let ChangePage = (value) => {
      store.setData("biddingPage", value);
      store.setData("biddingCurrentPage", value);
      store.reloadTableData(props.showType);
    };
    let currentPage = computed(() => storeToRefs(store).biddingCurrentPage);
    let pageSize = computed(() => storeToRefs(store).biddingSize);
    if(props.showType==2){
      tableData = computed(() => storeToRefs(store).priceLoadData);
      ChangeSize = (value) => {
        store.setData("priceSize", value);
        store.reloadTableData(props.showType);
      };
      ChangePage = (value) => {
        store.setData("pricePage", value);
        store.setData("priceCurrentPage", value);
        store.reloadTableData(props.showType);
      };
      currentPage = computed(() => storeToRefs(store).priceCurrentPage);
      pageSize = computed(() => storeToRefs(store).priceSize);
      tableTotal = computed(() => storeToRefs(store).priceTotal);
    }
    const data = reactive({
      currentPage,
      pageSize,
      tableData,
      tableTotal,
      ChangeSize,
      ChangePage,
    });
    const getHeaderCellStyle = () => {
      return { color: "#000", padding: "0 10px" };
    };
    const formatNumber = (number, decimals = 2, decPoint = '.', thousandsSep = ',') => {
        number = (number + '').replace(/[^0-9+-Ee.]/g, '')
        let n = !isFinite(+number) ? 0 : +number
        let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
        let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
        let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
        let s = ''
        let toFixedFix = function (n, prec) {
            let k = Math.pow(10, prec)
            return '' + Math.ceil(n * k) / k
        }
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
        let re = /(-?\d+)(\d{3})/
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, '$1' + sep + '$2')
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || ''
            s[1] += new Array(prec - s[1].length + 1).join('0')
        }
        return s.join(dec)
    }
    return {
      ...data,
      handleClick,
      // loadData,
      getHeaderCellStyle,
      formatNumber
    };
  },
};
</script>

<style scoped>
@import url("./newBiddingTable.css");
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    padding: 0px 0px;
}
</style>

